import { withRouter } from 'react-router';
import React, { type JSX } from 'react';
import { withAppContext } from '../../contexts/AppContext';
import ContentViewer from './ContentViewer';
import AuthorControls from './action-controls/AuthorControls';
import RouterPaths from '../../common/RouterPaths';
import constants from '../../common/constants';
import { Container, Header, Box, Button } from '@amzn/awsui-components-core';
import { ShowAllCommentsButton } from '../inline-comment';

class ReadOnlyContentViewer extends ContentViewer {
  protected showPublicationHistory = true;
  protected showSectionalComments = true;
  protected showLastBarRaiserEvaluation: boolean = true;

  protected showReviewFeedback = () => {
    return true;
  };

  // @ts-expect-error TS2416 - strict migration
  protected renderActions = () => {
    return (
      <Container header={<Header variant="h3">Actions</Header>}>
        <Box padding={{ top: 's' }}>
          <ShowAllCommentsButton handleShowAllComments={this.handleShowAllComments} />
        </Box>
      </Container>
    );
  };

  protected getBreadcrumbItems(): Array<{ text: string; href: string }> {
    return [
      {
        href: this.props.location?.state?.navigateBackTo || RouterPaths.MY_CONTENT,
        text: constants.BACK_TO_CONTENTS_HEADER,
      },
    ];
  }

  protected renderControls(): false | JSX.Element {
    const { workflow } = this.state;
    // @ts-expect-error TS18048 - strict migration
    return <AuthorControls contentId={workflow.contentId} workflow={workflow} readView />;
  }

  private handleShowAllComments = () => {
    this.setShowInlineCommentsInReviewerPage(true);
  };
}

export default withRouter(withAppContext(ReadOnlyContentViewer));
